import React, { useEffect, useState } from "react"
import { withRouter, Link } from "react-router-dom"

import MetaTags from "react-meta-tags"

import { Container } from "reactstrap"
import Breadcrumbs from "components/Common/Breadcrumb"
import Table from "./Table"
import { useSelector, useDispatch } from "react-redux"
import { getAllAcca7 } from "store/Acca7/actions"
import {sitename} from "../../../constants/constants";

const Acca7 = props => {
  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(getAllAcca7())
  }, [])

  const Acca7 = useSelector(
    state => state.acca7.Index ?? []
  )

  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>{sitename}</title>
        </MetaTags>
        <Container fluid>
          {/* Render Breadcrumb */}
          <Breadcrumbs title="Admin" breadcrumbItem="Acca7" />
        </Container>
        <Table data={Acca7} />
      </div>
    </React.Fragment>
  )
}

export default withRouter(Acca7)
